<template>
    <SmartBreadcrumbs
        type="InertiaLink"
        :pages="[
            {
                name: $tc('messages.groups', 2),
                href: meta.links.group_index,
            },
            {
                name: group.name,
                href: meta.links.group_show,
            },
            {
                name: $tc('messages.factions', 2),
                href: meta.links.show,
            },
            {
                name: $t('messages.edit'),
                href: null,
            },
        ]"
    />
    <div class="flex justify-end">
        <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" form="group_faction" />
    </div>
    <form :action="meta.links.update" method="post" @submit.prevent="submit" class="mt-3" id="group_faction">
        <table class="min-w-full divide-y divide-gray-200 relative">
            <thead class="sticky top-0 bg-gray-50 z-10">
                <tr>
                    <th
                        class="sticky left-0 px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {{ $t('messages.student') }}
                    </th>
                    <th
                        v-for="faction in factions"
                        :key="faction.id"
                        class="px-4 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        <div class="flex justify-center items-center space-x-2">
                            <span>
                                {{ faction.name }}
                            </span>
                            <img
                                :src="faction.image_path"
                                v-if="faction.image_path"
                                alt="faction image"
                                class="h-10 object-contain"
                            />
                        </div>
                    </th>
                    <th
                        class="px-4 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {{ $t('messages.without_faction') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="odd:bg-white even:bg-gray-50" v-for="(student, index) in form.students" :key="student.id">
                    <td
                        class="sticky left-0 px-4 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 z-10"
                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                    >
                        {{ student.full_name }}
                    </td>
                    <td
                        v-for="faction in factions"
                        :key="faction.id"
                        class="text-center px-4 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 relative"
                    >
                        <label
                            class="absolute inset-0 flex justify-center items-center"
                            :class="{ 'bg-indigo-100': student.faction_id == faction.id }"
                        >
                            <input
                                type="radio"
                                :name="`student_${student.id}_faction`"
                                id=""
                                :value="faction.id"
                                v-model="student.faction_id"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                        </label>
                    </td>
                    <td
                        class="text-center px-4 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 relative"
                    >
                        <label
                            class="absolute inset-0 flex justify-center items-center"
                            :class="{ 'bg-indigo-100': student.faction_id === null }"
                        >
                            <input
                                type="radio"
                                :name="`student_${student.id}_faction`"
                                id=""
                                :value="null"
                                v-model="student.faction_id"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'students', 'factions', 'group'],
    data() {
        return {
            form: this.$inertia.form({
                students: this.students,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
